/* Private gallery: direct-link archive browsing, shortlist and inquiry-field handoff. */
(function () {
  'use strict';
  if (window.__nhlPrivateGallery) return;
  window.__nhlPrivateGallery = true;

  var root = document.querySelector('[data-private-gallery]');
  if (!root) return;

  var stateKey = 'nhl:private-gallery:v1';
  var state = { granted: false, firstViewedAt: '', ref: '', images: 0 };
  var content = root.querySelector('[data-gallery-content]');
  var grid = root.querySelector('[data-gallery-grid]');
  var template = root.querySelector('[data-gallery-template]');
  var archiveData = root.querySelector('[data-gallery-archive]');
  var loadMore = root.querySelector('[data-gallery-load-more]');
  var loadMoreLabel = root.querySelector('[data-gallery-load-more-label]');
  var loadMoreCount = root.querySelector('[data-gallery-load-more-count]');
  var stat = root.querySelector('[data-gallery-stat]');
  var yearSelect = root.querySelector('[data-gallery-year]');
  var archive = null;
  var activeYear = 'all';
  var activeView = 'all';
  var renderedCount = 0;
  var pageSize = 96;
  var populated = false;

  var shortlistKey = 'nhl:private-gallery:shortlist:v1:' + (root.getAttribute('data-gallery-customer') || 'guest');
  var shortlist = [];
  var byRef = {};
  var maxShortlist = 40;
  var pendingKey = 'nhl:private-gallery:shortlist-pending:v1';
  var idPattern = /^NHL-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var clarityQueue = [];
  var clarityTimer = null;
  var shopifyQueue = [];
  var shopifyTimer = null;
  var gridSeen = false;
  var gridBrowsed = false;
  var shortlistBarSeen = false;
  var formStarted = false;
  var submitting = false;
  var openWatch = null;
  var feedbackTimer = null;

  function permission() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      return privacy && typeof privacy.analyticsProcessingAllowed === 'function' ? (privacy.analyticsProcessingAllowed() ? 'allowed' : 'denied') : 'unknown';
    } catch (_) { return 'unknown'; }
  }

  function feedback(message) {
    var target = root.querySelector('[data-gallery-feedback]');
    if (target) target.textContent = message;
    if (feedbackTimer) clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(function () { if (target) target.textContent = ''; }, 5000);
  }

  function safe(value, fallback) {
    var clean = String(value || '').replace(/[^a-zA-Z0-9_.-]+/g, '_').slice(0, 80);
    return clean || fallback || '';
  }

  function flushClarity() {
    if (permission() === 'denied') { clarityQueue = []; return; }
    if (permission() !== 'allowed') return;
    if (typeof window.clarity !== 'function') return;
    while (clarityQueue.length) {
      var call = clarityQueue[0];
      try { window.clarity.apply(window, call); } catch (_) { return; }
      clarityQueue.shift();
    }
    if (clarityTimer) { clearInterval(clarityTimer); clarityTimer = null; }
  }

  function sendClarity(method, name, value) {
    if (permission() === 'denied') return;
    clarityQueue.push(value === undefined ? [method, name] : [method, name, value]);
    flushClarity();
    if (clarityQueue.length && !clarityTimer) {
      var attempts = 0;
      clarityTimer = setInterval(function () {
        flushClarity();
        if (++attempts >= 240 && clarityTimer) { clearInterval(clarityTimer); clarityTimer = null; }
      }, 250);
    }
  }

  function flushShopify() {
    var shop = window.Shopify;
    if (!shop || !shop.analytics || typeof shop.analytics.publish !== 'function') return;
    while (shopifyQueue.length) {
      try { shop.analytics.publish('nhorology:gallery_engagement', shopifyQueue[0]); } catch (_) { return; }
      shopifyQueue.shift();
    }
    if (shopifyTimer) { clearInterval(shopifyTimer); shopifyTimer = null; }
  }

  function sendShopify(name, data) {
    var shop = window.Shopify;
    if (!shop || !shop.theme || shop.theme.role !== 'main' || shop.designMode || /[?&](preview_theme_id|preview_key|preview_script_id)=/.test(location.search)) return;
    var payload = { event_name: name, gallery_source: /^NHL-[0-9a-f-]{36}$/i.test(state.ref) ? 'quote' : state.ref === 'thank_you' ? 'thank_you' : 'direct' };
    if (data && Number.isFinite(Number(data.gallery_count))) payload.gallery_count = Number(data.gallery_count);
    if (data && Number.isFinite(Number(data.gallery_photos))) payload.gallery_photos = Number(data.gallery_photos);
    if (data && Number.isFinite(Number(data.gallery_total))) payload.gallery_total = Number(data.gallery_total);
    if (data && data.gallery_year) payload.gallery_year = safe(data.gallery_year, 'unknown');
    shopifyQueue.push(payload);
    flushShopify();
    if (shopifyQueue.length && !shopifyTimer) {
      var attempts = 0;
      shopifyTimer = setInterval(function () {
        flushShopify();
        if (++attempts >= 240 && shopifyTimer) { clearInterval(shopifyTimer); shopifyTimer = null; shopifyQueue = []; }
      }, 250);
    }
  }

  document.addEventListener('visitorConsentCollected', function () { setTimeout(flushClarity, 0); setTimeout(flushShopify, 0); });
  window.addEventListener('load', function () { flushClarity(); flushShopify(); }, { once: true });

  function track(name, data) {
    if (!name) return;
    try {
      sendClarity('event', name);
      sendShopify(name, data);
      var leadEvent = { private_gallery_landed: 'gallery_visit', private_gallery_grid_browsed: 'gallery_browse', private_gallery_image_opened: 'image_view', private_gallery_liked: 'image_like', private_gallery_shortlist_opened: 'shortlist_open', private_gallery_shortlist_started: 'shortlist_start', private_gallery_shortlist_submitted: 'shortlist_submit' }[name];
      if (leadEvent && typeof window.nhlTrackGalleryLeadEvent === 'function') window.nhlTrackGalleryLeadEvent(leadEvent, state.ref);
    } catch (_) {}
  }

  function tag(name, value) {
    if (!value) return;
    sendClarity('set', name, safe(value, 'unknown'));
  }

  function save() {
    try { sessionStorage.setItem(stateKey, JSON.stringify(state)); } catch (_) {}
  }

  function load() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(stateKey) || 'null');
      if (saved) state = Object.assign(state, saved);
    } catch (_) {}
    var query = new URLSearchParams(location.search);
    var ref = query.get('gallery_ref') || query.get('utm_campaign');
    // A new direct visit must not inherit an earlier enquiry ID from this tab.
    state.ref = ref ? safe(ref, 'direct') : 'direct';
    // Shopify's contact confirmation does not preserve the gallery_ref query.
    // Recover the original enquiry only for a recent server-confirmed shortlist.
    if (root.querySelector('[data-shortlist-sent]')) {
      try {
        var pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        if (pending && idPattern.test(pending.ref || '') && Date.now() >= pending.at && Date.now() - pending.at <= 1800000) state.ref = pending.ref;
      } catch (_) {}
    }
    // A new enquiry in this browser must not inherit another customer's favourites.
    if (idPattern.test(state.ref)) shortlistKey += ':' + state.ref.toLowerCase();
    save();
  }

  function filteredItems() {
    if (!archive || !Array.isArray(archive.items)) return [];
    return archive.items.filter(function (item) {
      return (activeYear === 'all' || item[0] === activeYear) && (activeView !== 'shortlist' || isLiked(item[2]));
    });
  }

  function updateStat(items) {
    if (!stat) return;
    var photos = items.reduce(function (sum, item) { return sum + item[1].length; }, 0);
    stat.textContent = items.length.toLocaleString() + ' watches · ' + photos.toLocaleString() + ' photos' + (activeYear === 'all' ? ', newest first' : ' in this view');
  }

  function captionFor(item) {
    return 'Ref ' + item[2] + (item[0] ? ' · ' + item[0] : '');
  }

  function loadShortlist() {
    try {
      var saved = JSON.parse(localStorage.getItem(shortlistKey) || '[]');
      if (Array.isArray(saved)) shortlist = saved.filter(function (ref) { return byRef[ref]; }).slice(0, maxShortlist);
    } catch (_) {}
  }

  function saveShortlist() {
    try { localStorage.setItem(shortlistKey, JSON.stringify(shortlist)); } catch (_) {}
  }

  function isLiked(ref) {
    return shortlist.indexOf(ref) !== -1;
  }

  function setLikeButton(button, ref) {
    var liked = isLiked(ref);
    button.setAttribute('aria-pressed', liked ? 'true' : 'false');
    var label = button.querySelector('[data-like-label]');
    if (label) label.textContent = liked ? 'In your shortlist' : 'Add to shortlist';
    else button.setAttribute('aria-label', (liked ? 'Remove Ref ' : 'Add Ref ') + ref + (liked ? ' from' : ' to') + ' your shortlist');
  }

  function toggleLike(ref) {
    if (!byRef[ref]) return;
    if (isLiked(ref)) {
      shortlist = shortlist.filter(function (value) { return value !== ref; });
      feedback('Ref ' + ref + ' removed from your shortlist.');
      track('private_gallery_unliked', { gallery_count: shortlist.length });
    } else {
      if (shortlist.length >= maxShortlist) { feedback('Your shortlist has 40 watches. Remove one before adding another, or send these to Namir.'); track('private_gallery_shortlist_limit'); return; }
      shortlist.push(ref);
      track('private_gallery_liked', { gallery_count: shortlist.length });
      feedback('Ref ' + ref + ' saved. ' + shortlist.length + (shortlist.length === 1 ? ' watch' : ' watches') + ' ready to send to Namir.');
    }
    saveShortlist();
    updateShortlist();
    if (activeView === 'shortlist') renderArchive(true);
  }

  function updateShortlist() {
    root.querySelectorAll('[data-like-ref]').forEach(function (button) {
      setLikeButton(button, Number(button.getAttribute('data-like-ref')));
    });
    var bar = root.querySelector('[data-shortlist-bar]');
    var count = root.querySelector('[data-shortlist-count]');
    if (count) count.textContent = shortlist.length + (shortlist.length === 1 ? ' watch' : ' watches') + ' saved';
    var countButton = root.querySelector('.private-gallery-shortlist-count-button');
    if (countButton) countButton.setAttribute('aria-label', shortlist.length + (shortlist.length === 1 ? ' watch' : ' watches') + ' in your shortlist. Review and send.');
    root.querySelectorAll('[data-gallery-saved-count]').forEach(function (node) { node.textContent = shortlist.length; });
    var lightboxSend = root.querySelector('[data-shortlist-lightbox-send]');
    if (lightboxSend) lightboxSend.hidden = shortlist.length === 0;
    var summary = root.querySelector('[data-shortlist-summary]');
    if (summary) summary.textContent = shortlist.length ? shortlist.length + (shortlist.length === 1 ? ' saved watch' : ' saved watches') + ' will be sent with your contact details.' : 'Your shortlist is empty. Close this window and tap a heart to add a watch.';
    var reviewCount = root.querySelector('[data-shortlist-review-count]');
    if (reviewCount) reviewCount.textContent = '(' + shortlist.length + ')';
    document.documentElement.classList.toggle('pg-has-shortlist', shortlist.length > 0);
    if (bar) {
      bar.hidden = shortlist.length === 0;
      if (!bar.hidden && !shortlistBarSeen) {
        shortlistBarSeen = true;
        track('private_gallery_shortlist_visible', { gallery_count: shortlist.length });
      }
    }
    renderShortlist();
  }

  function renderShortlist() {
    var list = root.querySelector('[data-shortlist-list]');
    var field = root.querySelector('[data-shortlist-field]');
    var countField = root.querySelector('[data-shortlist-count-field]');
    var submit = root.querySelector('[data-shortlist-submit]');
    if (!list || !archive) return;
    list.replaceChildren();
    var lines = [];
    shortlist.forEach(function (ref) {
      var item = byRef[ref];
      var li = document.createElement('li');
      var image = document.createElement('img');
      image.src = archive.base + item[1][0];
      image.alt = 'Ref ' + ref;
      image.loading = 'lazy';
      image.width = 200;
      image.height = 200;
      var label = document.createElement('span');
      label.textContent = 'Ref ' + ref;
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '\u00d7';
      remove.setAttribute('aria-label', 'Remove Ref ' + ref);
      remove.addEventListener('click', function () { toggleLike(ref); });
      var preview = document.createElement('button');
      preview.type = 'button';
      preview.className = 'private-gallery-shortlist-preview';
      preview.setAttribute('aria-label', 'View photos of Ref ' + ref);
      preview.append(image, label);
      preview.addEventListener('click', function () { if (openWatch) openWatch(item); });
      remove.className = 'private-gallery-shortlist-remove';
      li.append(preview, remove);
      list.appendChild(li);
      lines.push(captionFor(item) + ' — ' + archive.base + item[1][0]);
    });
    if (field) field.value = lines.join('\n');
    if (countField) countField.value = String(shortlist.length);
    if (submit) submit.disabled = shortlist.length === 0 || submitting;
  }

  function bindShortlist() {
    var dialog = root.querySelector('[data-shortlist-dialog]');
    var close = root.querySelector('[data-shortlist-close]');
    var form = root.querySelector('#private-gallery-shortlist');
    root.querySelectorAll('[data-shortlist-open]').forEach(function (open) { if (dialog) open.addEventListener('click', function () {
      renderShortlist();
      var lightbox = root.querySelector('[data-gallery-lightbox]');
      if (lightbox && lightbox.open) lightbox.close();
      dialog.showModal ? dialog.showModal() : dialog.setAttribute('open', '');
      dialog.scrollTop = 0;
      var title = dialog.querySelector('h2');
      if (title) title.focus({ preventScroll: true });
      track('private_gallery_shortlist_opened', { gallery_count: shortlist.length });
    }); });
    if (close && dialog) close.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
    if (dialog) dialog.addEventListener('close', function () { track('private_gallery_shortlist_closed', { gallery_count: shortlist.length }); });
    if (form) {
      form.addEventListener('input', function (event) {
        if (!formStarted && /^(INPUT|TEXTAREA)$/.test(event.target.tagName) && event.target.type !== 'hidden') { formStarted = true; track('private_gallery_shortlist_started'); }
      });
      form.addEventListener('invalid', function () { track('private_gallery_shortlist_invalid'); }, true);
    }
    if (form) form.addEventListener('submit', function (event) {
      renderShortlist();
      if (!shortlist.length) { event.preventDefault(); return; }
      if (submitting) { event.preventDefault(); return; }
      // The attribution script has already stamped this form's Inquiry ID (capture phase).
      var input = form.querySelector('input[name="contact[Inquiry ID]"]');
      try {
        if (input && idPattern.test(input.value)) sessionStorage.setItem(pendingKey, JSON.stringify({ id: input.value, ref: state.ref, at: Date.now(), count: shortlist.length }));
      } catch (_) {}
      track('private_gallery_shortlist_submitted', { gallery_count: shortlist.length });
      // Keep native Shopify/hCaptcha submission. Never label an attempt as delivered.
      submitting = true;
      var submit = form.querySelector('[data-shortlist-submit]');
      if (submit) { submit.disabled = true; submit.textContent = 'Sending…'; }
      setTimeout(function () {
        submitting = false;
        if (submit) { submit.disabled = !shortlist.length; submit.textContent = 'Send shortlist to Namir'; }
      }, 15000);
    });
    if (root.querySelector('.private-gallery-shortlist-error') && dialog) {
      dialog.showModal ? dialog.showModal() : dialog.setAttribute('open', '');
      track('private_gallery_shortlist_error');
    }
    if (root.querySelector('[data-shortlist-sent]')) {
      shortlist = [];
      saveShortlist();
      reportShortlistSent();
      var sent = root.querySelector('[data-shortlist-sent]');
      if (sent && sent.scrollIntoView) sent.scrollIntoView({ block: 'center' });
    }
  }

  // Runs only on the server-confirmed "Sent" render, once per submission. Never a Lead:
  // GA4 and Meta receive the confirmed Shopify event through their consent-managed pixels.
  function reportShortlistSent() {
    var pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (_) { return; }
    if (!pending || !idPattern.test(pending.id || '') || !Number.isFinite(pending.at) || Date.now() < pending.at || Date.now() - pending.at > 1800000 || pending.done) return;
    pending.done = true;
    try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch (_) {}
    var data = { event_id: pending.id, watch_count: Math.max(0, Math.min(maxShortlist, Number(pending.count) || 0)) };
    sendClarity('event', 'private_gallery_shortlist_sent');
    sendClarity('set', 'gallery_shortlist', 'sent');
    sendClarity('upgrade', 'gallery shortlist sent');
    if (typeof window.nhlTrackGalleryLeadEvent === 'function') window.nhlTrackGalleryLeadEvent('shortlist_confirmed', pending.ref);
    var shop = window.Shopify;
    var live = shop && shop.theme && shop.theme.role === 'main' && !shop.designMode && !/[?&](preview_theme_id|preview_key|preview_script_id)=/.test(location.search);
    if (!live) return;
    try { if (shop.analytics && typeof shop.analytics.publish === 'function') shop.analytics.publish('nhorology:gallery_shortlist_sent', data); } catch (_) {}
  }

  function cardFor(item, position) {
    var count = item[1].length;
    var card = document.createElement('div');
    card.className = 'private-gallery-card';
    var open = document.createElement('button');
    open.type = 'button';
    open.className = 'private-gallery-card-open';
    open.setAttribute('data-gallery-card', '');
    open.setAttribute('data-gallery-year', item[0] || 'Unknown');
    open.setAttribute('data-gallery-index', String(archive.items.indexOf(item)));
    open.setAttribute('aria-label', captionFor(item) + (count > 1 ? ', ' + count + ' photos' : ''));
    card.appendChild(open);
    var image = document.createElement('img');
    image.src = archive.base + item[1][0];
    image.alt = 'NHorology Lab watch, ' + captionFor(item);
    image.loading = position < 12 ? 'eager' : 'lazy';
    if (position < 12) image.setAttribute('fetchpriority', 'high');
    image.decoding = 'async';
    image.width = 400;
    image.height = 400;
    open.appendChild(image);
    var label = document.createElement('span');
    label.textContent = captionFor(item);
    open.appendChild(label);
    if (count > 1) {
      var badge = document.createElement('span');
      badge.className = 'private-gallery-card-count';
      badge.textContent = count + ' photos';
      open.appendChild(badge);
    }
    var like = document.createElement('button');
    like.type = 'button';
    like.className = 'private-gallery-like';
    like.setAttribute('data-like-ref', String(item[2]));
    like.textContent = '\u2665';
    setLikeButton(like, item[2]);
    card.appendChild(like);
    return card;
  }

  function renderArchive(reset) {
    if (!archive || !grid) return;
    var items = filteredItems();
    if (reset) {
      renderedCount = 0;
      grid.replaceChildren();
    }
    var nextItems = items.slice(renderedCount, renderedCount + pageSize);
    nextItems.forEach(function (item, index) { grid.appendChild(cardFor(item, renderedCount + index)); });
    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'private-gallery-fallback';
      empty.textContent = activeView === 'shortlist' ? 'No saved watches in this view. Choose All watches and tap a heart to start your shortlist.' : 'No watches in this year. Choose All years to keep browsing.';
      grid.appendChild(empty);
    }
    renderedCount += nextItems.length;
    updateStat(items);
    if (loadMore) {
      loadMore.hidden = renderedCount >= items.length;
      if (loadMoreCount) loadMoreCount.textContent = loadMore.hidden ? '' : (items.length - renderedCount).toLocaleString() + ' remaining';
      if (loadMoreLabel) loadMoreLabel.textContent = loadMore.hidden ? 'All work loaded' : 'Load more work';
    }
  }

  function populateYears() {
    if (!yearSelect || !archive || !Array.isArray(archive.items)) return;
    var years = Array.from(new Set(archive.items.map(function (item) { return item[0] || 'Unknown'; })))
      .sort(function (a, b) { return b.localeCompare(a, undefined, { numeric: true }); });
    years.forEach(function (year) {
      var option = document.createElement('option');
      option.value = year;
      option.textContent = year;
      yearSelect.appendChild(option);
    });
  }

  function bindControls() {
    root.querySelectorAll('[data-gallery-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeView = button.getAttribute('data-gallery-view');
        root.querySelectorAll('[data-gallery-view]').forEach(function (other) { other.setAttribute('aria-pressed', other === button ? 'true' : 'false'); });
        renderArchive(true);
        track(activeView === 'shortlist' ? 'private_gallery_saved_viewed' : 'private_gallery_all_viewed');
      });
    });
    if (yearSelect) yearSelect.addEventListener('change', function () {
      activeYear = yearSelect.value || 'all';
      renderArchive(true);
      track('private_gallery_year_viewed', { gallery_year: safe(activeYear, 'all') });
    });
    if (loadMore) loadMore.addEventListener('click', function () { renderArchive(false); track('private_gallery_more_loaded', { gallery_total: renderedCount }); });
  }

  function bindLightbox() {
    var lightbox = root.querySelector('[data-gallery-lightbox]');
    var lightboxImage = root.querySelector('[data-gallery-lightbox-image]');
    var lightboxCaption = root.querySelector('[data-gallery-lightbox-caption]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var likeCurrent = root.querySelector('[data-gallery-like-current]');
    var current = null;
    var frame = 0;
    var touchX = null;
    var touchY = null;
    var watchPrev = root.querySelector('[data-gallery-watch-prev]');
    var watchNext = root.querySelector('[data-gallery-watch-next]');

    function showFrame(step) {
      if (!current || !lightboxImage) return;
      var frames = current[1];
      frame = (frame + step + frames.length) % frames.length;
      lightboxImage.src = archive.base + frames[frame];
      lightboxImage.alt = 'NHorology Lab watch, ' + captionFor(current) + ', photo ' + (frame + 1) + ' of ' + frames.length;
      if (lightboxCaption) lightboxCaption.textContent = captionFor(current) + (frames.length > 1 ? ' · ' + (frame + 1) + ' / ' + frames.length : '');
      if (likeCurrent) {
        likeCurrent.setAttribute('data-like-ref', String(current[2]));
        setLikeButton(likeCurrent, current[2]);
      }
      if (prev) prev.hidden = frames.length < 2;
      if (next) next.hidden = frames.length < 2;
      if (step) track('private_gallery_photo_stepped', { gallery_photo: frame + 1 });
    }

    openWatch = function (item) {
      current = item;
      frame = 0;
      state.images += 1;
      save();
      track('private_gallery_image_opened', { gallery_year: safe(item[0], 'unknown'), gallery_photos: item[1].length });
      showFrame(0);
      var items = filteredItems();
      if (watchPrev) watchPrev.disabled = items.indexOf(current) <= 0;
      if (watchNext) watchNext.disabled = items.indexOf(current) === -1 || items.indexOf(current) >= items.length - 1;
      if (lightbox && !lightbox.open) lightbox.showModal ? lightbox.showModal() : lightbox.setAttribute('open', '');
    };
    function stepWatch(step) {
      var items = filteredItems(), index = items.indexOf(current), item = items[index + step];
      if (item) { openWatch(item); track('private_gallery_watch_stepped'); }
    }
    if (watchPrev) watchPrev.addEventListener('click', function () { stepWatch(-1); });
    if (watchNext) watchNext.addEventListener('click', function () { stepWatch(1); });

    if (likeCurrent) likeCurrent.addEventListener('click', function () { if (current) toggleLike(current[2]); });
    if (grid) grid.addEventListener('click', function (event) {
      var like = event.target.closest('[data-like-ref]');
      if (like && grid.contains(like)) { toggleLike(Number(like.getAttribute('data-like-ref'))); return; }
      var card = event.target.closest('[data-gallery-card]');
      if (!card || !grid.contains(card)) return;
      var item = archive.items[Number(card.getAttribute('data-gallery-index'))];
      if (item) openWatch(item);
    });
    if (prev) prev.addEventListener('click', function () { showFrame(-1); });
    if (next) next.addEventListener('click', function () { showFrame(1); });
    if (lightbox) {
      lightbox.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showFrame(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showFrame(1); }
      });
      lightbox.addEventListener('touchstart', function (event) { touchX = event.touches[0].clientX; touchY = event.touches[0].clientY; }, { passive: true });
      lightbox.addEventListener('touchend', function (event) {
        if (touchX === null || !current || current[1].length < 2) return;
        var dx = event.changedTouches[0].clientX - touchX;
        var dy = event.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) showFrame(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    root.querySelectorAll('[data-gallery-close]').forEach(function (button) {
      button.addEventListener('click', function () { if (lightbox && lightbox.close) lightbox.close(); else if (lightbox) lightbox.removeAttribute('open'); });
    });
  }

  function bindCta() {
    var cta = root.querySelector('[data-gallery-cta]');
    if (!cta) return;
    cta.addEventListener('click', function () {
      try {
        var url = new URL(cta.href, location.href);
        if (state.ref && state.ref !== 'direct') url.searchParams.set('gallery_ref', state.ref);
        cta.href = url.toString();
      } catch (_) {}
      track('private_gallery_cta_clicked', { gallery_ref: state.ref });
    });
  }

  function renderFallback() {
    if (!template || !grid) return;
    grid.replaceChildren();
    grid.appendChild(template.content.cloneNode(true));
    if (stat) stat.textContent = 'Selected work · full archive loading soon';
    if (loadMore) loadMore.hidden = true;
  }

  // Depth is relative to the currently loaded All-watches grid, not the full archive.
  // Only an actual page scroll records a milestone; modal and filtered views do not.
  function bindScrollDepth() {
    var reached = {};
    var scheduled = false;
    window.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        if (!grid || activeView !== 'all' || activeYear !== 'all' || document.querySelector('dialog[open]')) return;
        var bounds = grid.getBoundingClientRect();
        if (!Number.isFinite(bounds.height) || bounds.height <= 0 || bounds.top >= window.innerHeight) return;
        var depth = Math.max(0, Math.min(100, (window.innerHeight - bounds.top) / bounds.height * 100));
        [25, 50, 75, 100].forEach(function (level) {
          if (depth + 0.01 < level || reached[level]) return;
          reached[level] = true;
          sendClarity('event', 'private_gallery_scroll_' + level);
          if (typeof window.nhlTrackGalleryLeadEvent === 'function') window.nhlTrackGalleryLeadEvent('scroll_' + level, state.ref);
        });
      });
    }, { passive: true });
  }

  function observeGrid() {
    if (!grid || typeof IntersectionObserver !== 'function') return;
    var cards = grid.querySelectorAll('.private-gallery-card');
    if (!cards.length) return;
    var first = cards[0];
    var deeper = cards[Math.min(8, cards.length - 1)];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.target === first && !gridSeen) {
          gridSeen = true;
          track('private_gallery_grid_seen');
          observer.unobserve(first);
        }
        if (entry.target === deeper && !gridBrowsed) {
          if (!gridSeen) {
            gridSeen = true;
            track('private_gallery_grid_seen');
            observer.unobserve(first);
          }
          gridBrowsed = true;
          track('private_gallery_grid_browsed');
          observer.unobserve(deeper);
        }
      });
    }, { threshold: 0.25 });
    observer.observe(first);
    if (deeper !== first) observer.observe(deeper);
  }

  function showContent() {
    if (populated || !content) return;
    populated = true;
    state.granted = true;
    if (!state.firstViewedAt) state.firstViewedAt = new Date().toISOString();
    save();
    track('private_gallery_viewed', { gallery_ref: state.ref });
    tag('private_gallery', 'viewed');
    // Lets a lead's gallery visit be found in Clarity by their inquiry ID (Custom ID filter).
    if (idPattern.test(state.ref)) sendClarity('identify', state.ref);
    bindControls();
    bindLightbox();
    bindCta();
    try {
      archive = JSON.parse(archiveData.textContent);
      if (!archive || !Array.isArray(archive.items)) throw new Error('archive missing');
      archive.items.forEach(function (item) { byRef[item[2]] = item; });
      loadShortlist();
      populateYears();
      renderArchive(true);
      observeGrid();
      bindScrollDepth();
      bindShortlist();
      updateShortlist();
      track('private_gallery_archive_loaded', { gallery_total: archive.items.length });
    } catch (_) {
      archive = null;
      renderFallback();
      track('private_gallery_archive_fallback', { gallery_ref: state.ref });
    }
  }

  function addFormFields(target) {
    if (!target || !target.querySelector('input[name="contact[email]"]')) return;
    var values = {
      'Private gallery viewed': state.granted ? 'yes' : 'no',
      'Private gallery ref': state.ref,
      'Private gallery first viewed UTC': state.firstViewedAt,
      'Private gallery image opens': String(state.images)
    };
    Object.keys(values).forEach(function (label) {
      var name = 'contact[' + label + ']';
      var field = target.querySelector('input[name="' + name + '"]');
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; target.appendChild(field); }
      field.value = values[label];
    });
  }

  document.addEventListener('nhlGalleryPrefilled', function () { tag('gallery_contact_prefilled', 'yes'); track('private_gallery_contact_prefilled'); });
  load();
  track('private_gallery_landed', { gallery_ref: state.ref });
  tag('private_gallery_ref', state.ref);
  document.addEventListener('submit', function (event) { addFormFields(event.target); }, true);
  document.querySelectorAll('form').forEach(addFormFields);

  showContent();
})();
